import React, { Fragment, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import {
  AuthOuterWrapper,
  Form,
  ErrorWrapper,
  AuthHeader,
  HeaderImg,
  HeaderText,
  FooterText,
  FooterWrapper,
} from './AuthWrappers';
import CssTextField from '../../Inputs/CssTextField';
import CustomizedButton from '../../Buttons/CustomizedButton';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import WelcomeImg from '../../../assets/vectors/mirage-welcome.png';

const SignIn = ({ login, error, resetPassword }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const onLogin = () => {
    login(email, password);
  };

  return (
    <AuthOuterWrapper>
      <AuthHeader>
        <HeaderImg src={WelcomeImg} alt='welcome-img' />
        <HeaderText>
          <FormattedMessage id='signin.welcome-msg' />
        </HeaderText>
      </AuthHeader>
      <ErrorWrapper show={error} severity='error'>
        {error ? <FormattedMessage id={error} /> : ''}
      </ErrorWrapper>
      {error === 'login.user-banned' ? (
        <Fragment>
          <Typography style={{ margin: '1rem', textAlign: 'center' }} variant='body2'>
            <FormattedMessage id='login.user-banned-contact-support' />
          </Typography>
          <Link
            style={{ marginBottom: '1rem' }}
            component='button'
            variant='body2'
            onClick={() => {
              window.open('https://intereact.customerly.help/', '_blank');
            }}
          >
            <FormattedMessage id='login.user-banned-link' />
          </Link>
        </Fragment>
      ) : null}
      <Form>
        <CssTextField
          label={<FormattedMessage id='signin.email-field' />}
          setValue={(e) => setEmail(e.target.value)}
          flexGrow={2}
        />
        <CssTextField
          label={<FormattedMessage id='signin.password-field' />}
          inputType='password'
          setValue={(e) => setPassword(e.target.value)}
          flexShrink={0}
        />
      </Form>
      <CustomizedButton customButtonClicked={() => onLogin()} style={{ margin: '1rem' }}>
        <FormattedMessage id='signin.button' />
      </CustomizedButton>
      <FooterWrapper center>
        <FooterText onClick={() => resetPassword()}>
          <FormattedMessage id='signin.forgot-field' />
        </FooterText>
      </FooterWrapper>
    </AuthOuterWrapper>
  );
};

export default SignIn;
